import { v5 as uuidv5 } from 'uuid'

export function intakeSiteId(siteUrn: string): string {
  const normalized = siteUrn.trim()
  if (!normalized) throw new Error('site URN is required')
  return uuidv5(normalized, uuidv5.URL)
}
